import { TabsBase } from "./app.tabs-base.js";

var featured_products_tabs_default = (() => {
    if (customElements.get("featured-products-tabs")) return;
    customElements.define("featured-products-tabs", class FeaturedProductsTabs extends TabsBase {
        onTabActivated(tab) {
            this.updateShopAll(tab, "[data-fp-shop-all]");
            this.querySelector("slider-controls")?.refreshState();
        }
    });
})();